<template>
  <div class="t" :class="colorClass[colorIndex - 1]">
    <span>{{ num > 9 ? '' : '0' }}{{ num }}</span>
  </div>
</template>

<script>
export default {
  name: 'Triangle',
  props: {
    num: {
      type: Number,
    },
  },
  data() {
    return {
      colorClass: ['pink', 'purple', 'green', 'grey'],
    }
  },
  computed: {
    colorIndex() {
      return this.num > 4 ? 4 : this.num
    },
  },
}
</script>

<style lang="less" scoped>
.t {
  background: center/contain no-repeat;
  position: absolute;
  width: 49px;
  height: 56px;
  top: -3px;

  &.pink {
    background-image: url(../../../assets/pink.png);
  }
  &.purple {
    background-image: url(../../../assets/purple.png);
  }
  &.green {
    background-image: url(../../../assets/green.png);
  }
  &.grey {
    background-image: url(../../../assets/grey.png);
  }
  span {
    font-size: 22px;
    color: #ffffff;
    font-family: KravitzExtraThermal;
    position: absolute;
    top: 4px;
    left: 6px;
    font-weight: bold;
    text-align: center;
  }
}
</style>
